// extracted by mini-css-extract-plugin
module.exports = {"options":"skivSG","option":"jr5Pll"};